import(/* webpackMode: "eager" */ "/app/apps/web/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["SkipToContent"] */ "/app/apps/web/src/components/SkipToContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/apps/web/src/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WorkspaceProvider"] */ "/app/apps/web/src/lib/workspace-context.tsx");
